export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'contact_edit_manage',
  'contact_delete_manage',
  'contact_portfolio_bulk_manage',
  'report_manage',
  'report_team_manage',
  'inbox_view_manage',
  'campaign_manage',
  'kanban_manage',
  'label_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'inbox_view_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const INBOX_VIEW_PERMISSIONS = 'inbox_view_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const CONTACT_EDIT_PERMISSIONS = 'contact_edit_manage';

export const CONTACT_DELETE_PERMISSIONS = 'contact_delete_manage';

export const CONTACT_PORTFOLIO_BULK_PERMISSIONS = 'contact_portfolio_bulk_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const REPORTS_TEAM_PERMISSIONS = 'report_team_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const KANBAN_PERMISSIONS = 'kanban_manage';

export const CAMPAIGN_PERMISSIONS = 'campaign_manage';

export const LABELS_PERMISSIONS = 'label_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
